import { Action, combineReducers } from 'redux';

import { homeReducer } from '../../home/reducers/HomeReducer';
import { metricsDataStateReducer } from '../../metrics/reducers/MetricsDataStateReducer';
import { starterReducer } from '../../starters/reducers/StarterReducer';
import { uploadWorkbookReducer } from '../../uploadContent/reducers/UploadWorkbookReducer';
import { AppState } from '../state/AppState';
import { alertListInfoReducer } from './AlertListInfoReducer';
import { assetListReducer } from './AssetListReducer';
import { availableActionsForEntityReducer } from './AvailableActionsForEntityReducer';
import { breadcrumbsReducer } from './BreadcrumbsReducer';
import { contentExplorerReducer } from './contentExplorer/ContentExplorerReducer';
import { spaceInfoReducer } from './contentExplorer/SpaceInfoReducer';
import { displaySettingsReducer } from './DisplaySettingsReducer';
import { incrementRouterSpaceReactKeyReducer } from './IncrementRouterSpaceReactKeyReducer';
import { layoutTypeReducer } from './LayoutTypeReducer';
import { navigationReducer } from './NavigationReducer';
import { orderReducer } from './OrderReducer';
import { rootAdminUiStateReducer } from './RootAdminUiStateReducer';
import { routerErrorReducer } from './RouterErrorReducer';
import { sessionReducer } from './SessionReducer';
import { sitesReducer } from './SitesReducer';
import { userSettingsReducer } from './UserSettingsReducer';
import { vizPathReducer } from './VizPathReducer';

export const appReducer: (
  previousState: AppState,
  action: Action
) => AppState = combineReducers<AppState>({
  alertListInfo: alertListInfoReducer,
  assetList: assetListReducer,
  availableActionsForEntities: availableActionsForEntityReducer,
  breadcrumbs: breadcrumbsReducer,
  contentExplorer: contentExplorerReducer,
  displaySettings: displaySettingsReducer,
  order: orderReducer,
  session: sessionReducer,
  userSettings: userSettingsReducer,
  spaceInfo: spaceInfoReducer,
  navigationState: navigationReducer,
  sites: sitesReducer,
  home: homeReducer,
  layoutType: layoutTypeReducer,
  rootAdminUiState: rootAdminUiStateReducer,
  vizPath: vizPathReducer,
  routerSpaceReactKey: incrementRouterSpaceReactKeyReducer,
  reduxRouterError: routerErrorReducer,
  starters: starterReducer,
  uploadWorkbook: uploadWorkbookReducer,
  metricsData: metricsDataStateReducer,
});
